import getCurrentSpaceValue from "../../animate/utils/current-value/get-current-space-value";
import getCurrentCommaFn from "../../animate/utils/current-value/get-current-comma-fn";
import getCurrentLayer from "../../animate/utils/current-value/get-current-layer";
import getCurrentCommaValue from "../../animate/utils/current-value/get-current-comma-value";

/**
 * Set map level settings
 * @param {Map<String, any>} map
 * @param {Array<String>} split
 * @param {String} divider
 * @param {String} original
 * @param {Boolean} isFn
 * @param {String | null} name
 * @param {String} type
 */
const setLevelMap = (map, split, divider, original, isFn, name, type) => {
  map.set("is-fn", isFn);
  map.set("is-multiple", split?.length > 1);
  map.set("is-value", false);
  map.set("is-option", false);
  map.set("fn", isFn ? name : null);
  map.set("divider", divider);
  map.set("original", original);
  map.set("type", type);
  map.set("values", []);

  if (type === "layer") {
    map.set("get-current-layer", getCurrentLayer);
    map.set("isLayer", true);
  }

  if (type === "comma") {
    map.set(
      "get-current-comma",
      isFn ? getCurrentCommaFn : getCurrentCommaValue
    );
  }

  if (type === "space") {
    map.set("get-current-space", getCurrentSpaceValue);
  }
};

export default setLevelMap;
